import { Box, Typography } from '@mui/material';
import { ModalName } from 'app/enums';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'shared/components/Modal';
import { withModalOpenChecker } from 'shared/HOC/withModalOpenChecker';
import { useCreateAnnouncementForms } from 'modules/notifications/hooks/use-create-announcement-form';
import { LoaderButton } from 'shared/components/LoaderButton/LoaderButton';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import { createTournamentAnnouncement } from 'modules/notifications/store/notifications/repository';
import { EntityStoreName } from 'app/enums/store';
import { useEntityRepositoryStatus } from 'app/hooks/store';
import { NotificationsStoreStatus } from 'modules/notifications/store/notifications/enums';
import { modalsReducers } from '../../../../app/store/modal/slice';
import { dispatchUnwrap } from '../../../../app/utils/store';
import { CreateAnnouncementForm } from './CreateAnnouncementForm';

const { Creating } = NotificationsStoreStatus;

const CreateAnnouncementModalComponent: FC = () => {
  const dispatch = useDispatch();
  const creating = useEntityRepositoryStatus({ [EntityStoreName.Notifications]: Creating });
  const tournament = useSelector(currentTournamentSelector.tournament);

  const { form } = useCreateAnnouncementForms('');

  const onSubmitHandler = useCallback(
    ({ message }) => {
      const tournamentId = tournament?.id;
      dispatchUnwrap(createTournamentAnnouncement({ tournamentId, message }), {
        success: () => dispatch(modalsReducers.closeModal(ModalName.CreateAnnouncement)),
      });
    },
    [dispatch, tournament?.id]
  );

  return (
    <Modal
      maxWidth="md"
      contentHeight={224}
      disableEnforceFocus={true}
      name={ModalName.CreateAnnouncement}
      title="Add tournament announcement"
      actions={
        <LoaderButton
          fullWidth
          color="primary"
          variant="contained"
          loading={creating}
          onClick={form.handleSubmit(onSubmitHandler)}
        >
          Send Announcement
        </LoaderButton>
      }
    >
      <Box p={2}>
        <CreateAnnouncementForm form={form} />
        <Typography variant="body1" pt={1}>
          NOTE: It will be delivered to the tournament participants as both a notification and an
          email
        </Typography>
      </Box>
    </Modal>
  );
};

export const CreateAnnouncementModal = withModalOpenChecker(
  CreateAnnouncementModalComponent,
  ModalName.CreateAnnouncement
);
